import { Section } from '@advanza/advanza_generic'
import Page from 'components/ui/Page'
import PropTypes from 'prop-types'
import React from 'react'
import PromosFilter from './PromosFilter'
import PromosList from './PromosList'

class PromosPage extends React.Component {
    render() {
        return (
            <Page title="Marketing Promos">
                <Section y>
                    <Section s>
                        <h1>Marketing Promos</h1>
                    </Section>
                    <PromosFilter
                        filterId="admin"
                        defaultOptions={{ pageSize: 40, order: 'promo_id DESC' }}
                    />
                    <Section n>
                        <PromosList selectable filterId="admin" />
                    </Section>
                </Section>
            </Page>
        )
    }
}

PromosPage.propTypes = {}

export default PromosPage
